<script lang="ts" setup>
import { SortingProps } from "~/components/Filters/Utils/Modals/Sorting.props"
import { SortingModalItemProps } from "~/components/Filters/Utils/SortingModalItem.props"
import { ifHasNameAndValueSetCoookie } from "~/utils/cookies/setCookie"
import { SORTING_MODAL } from "~/utils/filters"

const props = defineProps<SortingProps>()
const emit =
  defineEmits<{
    (e: "onClose"): void
    (e: "onSelectItem", item: SortingModalItemProps): void
  }>()

const { sortFilter } = useGA4SiteEvents()
const onclickdFilter = (filter: SortingModalItemProps) => {
  sortFilter(filter)
}

watchEffect(() => {
  const name = props.activeCookieName
  const value = props.currentActive

  ifHasNameAndValueSetCoookie(name, value)
})
</script>

<template>
  <Teleport to="body">
    <FiltersUtilsSlide
      :name="SORTING_MODAL"
      open-from="bottom"
      :full-screen="false"
      no-background
      avoid-body-overflow
      @onClose="emit('onClose')"
    >
      <FiltersUtilsModalHead
        type="secondary"
        :title="$t('filters.utils.modals.sorting.sortBy')"
        @onClose="emit('onClose')"
      />
      <div class="space-y-4 bg-white p-4">
        <FiltersUtilsSortingModalItem
          v-for="item in items"
          :key="item.value"
          :="item"
          :active="item.value === currentActive"
          @onClick="
            () => {
              onclickdFilter(item)
              emit('onSelectItem', item)
            }
          "
        />
      </div>
    </FiltersUtilsSlide>
  </Teleport>
</template>
